import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateAssetLocation } from '../../../../state';

const RoomEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentAsset } = useAppSelector(state => state.asset);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateAssetLocation({ room: event.target.value }));
  };

  return (
    <TextField
      label="Room"
      size="small"
      fullWidth
      value={currentAsset?.room || ''}
      onChange={handleChange}
    />
  );
};

export default RoomEdit;
